import { Button } from '@/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/ui/dropdown-menu'
import { MaterialIcon } from '@/ui/material-icon'
import styles from './PipelineMoreMenu.module.scss'

export type PipelineMoreMenuProps = {
  onLockPipeline?: () => void
  onClearCanvas?: () => void
  onDeletePipeline?: () => void
  disableCanvasActions?: boolean
  canvasLocked?: boolean
}

export function PipelineMoreMenu({
  onLockPipeline,
  onClearCanvas,
  onDeletePipeline,
  disableCanvasActions = false,
  canvasLocked = false,
}: Readonly<PipelineMoreMenuProps>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button aria-label="Pipeline options" variant="ghost" size="icon">
          <MaterialIcon name="more_horiz" size={22} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={styles.content}
        align="end"
        sideOffset={6}
        alignOffset={0}
      >
        <DropdownMenuItem
          className={styles.item}
          disabled={disableCanvasActions}
          onSelect={() => onLockPipeline?.()}
        >
          <span className={styles.itemIcon} aria-hidden>
            <MaterialIcon name={canvasLocked ? 'lock_open' : 'lock'} size={20} />
          </span>
          {canvasLocked ? 'Unlock Canvas' : 'Lock Canvas'}
        </DropdownMenuItem>
        <DropdownMenuSeparator className={styles.separator} />
        <DropdownMenuItem
          className={styles.item}
          disabled={disableCanvasActions}
          onSelect={() => onClearCanvas?.()}
        >
          <span className={styles.itemIcon} aria-hidden>
            <MaterialIcon name="block" size={20} />
          </span>
          Clear Canvas
        </DropdownMenuItem>
        <DropdownMenuSeparator className={styles.separator} />
        <DropdownMenuItem
          className={styles.item}
          onSelect={() => onDeletePipeline?.()}
        >
          <span className={styles.itemIcon} aria-hidden>
            <MaterialIcon name="delete_forever" size={20} />
          </span>
          Delete Pipeline
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
